exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".array-img {\n  display: inline-block;\n  width: 85px;\n  height: 85px;\n  overflow: hidden;\n  margin-right: 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/admin/shared/display-file/display-file.component.scss
// module id = 260
// module chunks = 0 1